import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropArray, defaultPropObject } from "../../../constants";
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import { isFunc } from "../../../utils/type";
import Scrollbar from '../../../Scrollbar';
import { IOS_KEYBOARD_HEIGHT } from '../../constants';
import { Suggestion } from '../Suggestion';
import styles from './Suggestions.css';
var cx = classNames.bind(styles);
export var Suggestions = /*#__PURE__*/forwardRef(function Suggestions(_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      highlighted = _ref.highlighted,
      _ref$suggestions = _ref.suggestions,
      suggestions = _ref$suggestions === void 0 ? defaultPropArray : _ref$suggestions,
      maxHeight = _ref.scrollbarProps.maxHeight,
      onSuggestionSelect = _ref.onSuggestionSelect,
      namespace = _ref.namespace,
      appleKeyboardHack = _ref.appleKeyboardHack;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'suggestions'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  return /*#__PURE__*/React.createElement("div", getTestId(), /*#__PURE__*/React.createElement(Scrollbar, {
    ref: ref,
    maxHeight: appleKeyboardHack && typeof +maxHeight === 'number' ? +maxHeight - IOS_KEYBOARD_HEIGHT : maxHeight
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx('list'),
    role: "listbox"
  }, !!suggestions.length && suggestions.map(function (suggestion, index) {
    var label = suggestion.label;

    var handleClick = function handleClick() {
      if (isFunc(onSuggestionSelect)) {
        onSuggestionSelect(suggestion);
      }
    };

    return /*#__PURE__*/React.createElement(Suggestion, _extends({}, suggestion, {
      namespace: getNamespace(index.toString()),
      highlighted: highlighted === index,
      key: label,
      classes: classes,
      onClick: handleClick
    }));
  }))));
});